import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

import type { PopHighlightedFeaturesSectionProps } from './PopHighlightedFeaturesSection';
import { getSectionContentMotionProps } from './utils/getSectionContentMotionProps';

export interface PopHighlightedFeaturesSectionContentProps
  extends Pick<
    PopHighlightedFeaturesSectionProps,
    'activeIndex' | 'copy' | 'footer' | 'index' | 'title'
  > {
  readonly isInView: boolean;
  readonly isSticky: boolean;
}

const PopHighlightedFeaturesSectionContent = ({
  activeIndex,
  copy,
  footer,
  index,
  isInView,
  isSticky,
  title,
}: PopHighlightedFeaturesSectionContentProps) => {
  const t = useTranslations();
  const isVisible =
    (!isSticky && isInView) || (isSticky && activeIndex === index);
  const motionProps = getSectionContentMotionProps({ isVisible });

  return (
    <Motion
      data-cy="pop-highlighted-features-content"
      {...motionProps}
      suppressHydrationWarning
    >
      {title && (
        <Typography
          className={'mb-6 leading-tighter font-normal tracking-tighter'}
          Element="h2"
          variant="h3"
        >
          {t(title)}
        </Typography>
      )}
      <Typography
        className={cx('text-xl leading-snug tracking-tighter lg:text-2xl', {
          'text-2xl leading-tighter tracking-tighter md:text-4xl xl:text-[2.5rem]':
            !title,
        })}
      >
        <RichText {...copy} />
      </Typography>
      {footer}
    </Motion>
  );
};

export default PopHighlightedFeaturesSectionContent;
